"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));
var _isNan = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/number/is-nan"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _vue = _interopRequireDefault(require("vue"));
var _strftime = _interopRequireDefault(require("strftime"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var bufferTools = _interopRequireWildcard(require("@/libs/bufferTools"));
var _RemoveBeforeUpdate = _interopRequireDefault(require("./utils/RemoveBeforeUpdate"));
var _MessageListMessageCompact = _interopRequireDefault(require("./MessageListMessageCompact"));
var _MessageListMessageModern = _interopRequireDefault(require("./MessageListMessageModern"));
var _MessageListMessageInline = _interopRequireDefault(require("./MessageListMessageInline"));
var _LoadingAnimation = _interopRequireDefault(require("./LoadingAnimation"));
var _BufferKey = _interopRequireDefault(require("./BufferKey"));
var _MessageReactions = _interopRequireDefault(require("./MessageReactions"));
function _interopRequireWildcard(e, t) { if ("function" == typeof _WeakMap) var r = new _WeakMap(), n = new _WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && _Object$getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
require('@/libs/polyfill/Element.closest');
var log = _Logger.default.namespace('MessageList.vue');
var SCROLL_BUTTON_MESSAGE_THRESHOLD = 10;
var AUTO_SCROLL_MARGIN = 10;
var _default = exports.default = {
  components: {
    RemoveBeforeUpdate: _RemoveBeforeUpdate.default,
    MessageListMessageModern: _MessageListMessageModern.default,
    MessageListMessageCompact: _MessageListMessageCompact.default,
    MessageListMessageInline: _MessageListMessageInline.default,
    LoadingAnimation: _LoadingAnimation.default,
    BufferKey: _BufferKey.default,
    MessageReactions: _MessageReactions.default
  },
  props: ['buffer'],
  data: function data() {
    return {
      smooth_scroll: false,
      auto_scroll: true,
      showButton: false,
      userScrolledUp: false,
      force_smooth_scroll: null,
      chathistoryAvailable: true,
      hover_nick: '',
      message_info_open: null,
      timeToClose: false,
      startClosing: false,
      selectedMessages: Object.create(null),
      messageReactions: window.kiwi_reactions ? window.kiwi_reactions.store : {}
    };
  },
  computed: {
    thisMl: function thisMl() {
      return this;
    },
    shouldAutoEmbed: function shouldAutoEmbed() {
      if (this.buffer.isChannel() && this.buffer.setting('inline_link_auto_previews')) {
        return true;
      }
      if (this.buffer.isQuery() && this.buffer.setting('inline_link_auto_previews_query')) {
        return true;
      }
      return false;
    },
    listType: function listType() {
      if (this.$state.setting('messageLayout')) {
        log.info('Deprecation Warning: The config option \'messageLayout\' has been moved to buffers.messageLayout');
      }
      return this.buffer.setting('messageLayout') || this.$state.setting('messageLayout');
    },
    useExtraFormatting: function useExtraFormatting() {
      return this.buffer.setting('extra_formatting');
    },
    shouldShowChathistoryTools: function shouldShowChathistoryTools() {
      if (this.buffer.getNetwork().state !== 'connected') {
        return false;
      }
      var isCorrectBufferType = this.buffer.isChannel() || this.buffer.isQuery();
      var isSupported = !!this.buffer.getNetwork().ircClient.chathistory.isSupported();
      return isCorrectBufferType && isSupported && (0, _flags.default)(this.buffer).chathistory_available;
    },
    shouldRequestChannelKey: function shouldRequestChannelKey() {
      return this.buffer.getNetwork().state === 'connected' && this.buffer.isChannel() && (0, _flags.default)(this.buffer).channel_badkey;
    },
    ourNick: function ourNick() {
      return this.buffer ? this.buffer.getNetwork().nick : '';
    },
    filteredMessagesGroupedDay: function filteredMessagesGroupedDay() {
      var days = [];
      var lastDay = null;
      this.filteredMessages.forEach(function (message) {
        if (!lastDay || message.day_num !== lastDay) {
          days.push({
            dayNum: message.day_num,
            messages: []
          });
          lastDay = message.day_num;
        }
        days[days.length - 1].messages.push(message);
      });
      return days;
    },
    filteredMessages: function filteredMessages() {
      return bufferTools.orderedMessages(this.buffer);
    },
    shouldShowJoiningLoader: function shouldShowJoiningLoader() {
      return this.buffer.isChannel() && this.buffer.enabled && !this.buffer.joined && this.buffer.getNetwork().state === 'connected';
    },
    avgMessageHeight: function avgMessageHeight() {
      var els = this.$el ? (0, _toConsumableArray2.default)(this.$el.querySelectorAll('.kiwi-messagelist-message')) : [];
      if (!els.length) {
        return 30;
      }
      var total = els.reduce(function (sum, el) {
        return sum + el.offsetHeight;
      }, 0);
      return Math.max(1, Math.round(total / els.length));
    },
    hasReactionComponent: function hasReactionComponent() {
      return !!window.kiwi_reactions;
    },
    showSeenIndicator: function showSeenIndicator() {
      // Read receipts are only shared within private conversations
      if (!this.buffer.isQuery() || !this.buffer.setting('share_seen')) {
        return false;
      }
      var seenTime = (0, _flags.default)(this.buffer).seen_time;
      if (!seenTime) {
        // The other user has not shared their read position yet
        return false;
      }
      var seen = Date.parse(seenTime);
      if ((0, _isNan.default)(seen)) {
        return false;
      }
      var messages = this.filteredMessages;
      // Anchor the indicator to our own last message: if the other user
      // has read it, they've read everything we sent up to that point.
      // Newer messages from the other user must not hide the indicator
      // as it marks the read state of OUR messages, not theirs.
      for (var i = messages.length - 1; i >= 0; i--) {
        var _context;
        var message = messages[i];
        if (!(0, _includes.default)(_context = ['privmsg', 'action', 'notice']).call(_context, message.type) || !message.nick || message.nick.toLowerCase() !== this.ourNick.toLowerCase()) {
          continue;
        }
        var lastTime = message.tags && message.tags.time ? Date.parse(message.tags.time) : message.time;
        return !(0, _isNan.default)(lastTime) && lastTime <= seen;
      }

      // None of our own messages in this conversation
      return false;
    }
  },
  watch: {
    filteredMessages: function filteredMessages() {
      var _this = this;
      this.checkScrollingState();
      this.$nextTick(function () {
        _this.maybeScrollToBottom();
        if (_this.userScrolledUp) {
          _this.showButton = true;
        } else {
          _this.checkScroll();
        }
      });
    },
    buffer: function buffer(newBuffer, oldBuffer) {
      var _this2 = this;
      if (oldBuffer) {
        oldBuffer.isMessageTrimming = true;
      }
      if (!newBuffer) {
        return;
      }
      this.message_info_open = null;
      if (this.buffer.getNetwork().state === 'connected') {
        (0, _flags.default)(newBuffer).has_opened = true;
      }
      this.auto_scroll = true;
      this.showButton = false;
      this.userScrolledUp = false;
      this.force_smooth_scroll = false;
      this.$nextTick(function () {
        _this2.scrollToBottom();
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.addCopyListeners();
    document.addEventListener('click', this.handleDocumentClick);
    this.$nextTick(function () {
      _this3.scrollToBottom();
    });
    this.listen(this.$state, 'mediaviewer.opened', function () {
      _this3.$nextTick(_this3.maybeScrollToBottom.apply(_this3));
    });
    this.listen(this.$state, 'messagelist.scrollto', function (opt) {
      if (opt && opt.id) {
        _this3.maybeScrollToId(opt.id);
      }
    });
    var scroller = this.$refs.scroller;
    scroller.addEventListener('scroll', this.handleScroll);
    this.checkScroll();
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    document.removeEventListener('click', this.handleDocumentClick);
    var scroller = this.$refs.scroller;
    if (scroller) {
      scroller.removeEventListener('scroll', this.handleScroll);
    }
  },
  methods: {
    handleVisibilityChange: function handleVisibilityChange() {
      if (!document.hidden) {
        this.maybeScrollToBottom();
      }
    },
    isTemplateVue: function isTemplateVue(template) {
      var isVue = template instanceof _vue.default;
      if (isVue && !window.kiwi_deprecations_messageTemplate) {
        window.kiwi_deprecations_messageTemplate = true;
      }
      return isVue;
    },
    isHoveringOverMessage: function isHoveringOverMessage(message) {
      return message.nick && message.nick.toLowerCase() === this.hover_nick.toLowerCase();
    },
    toggleMessageInfo: function toggleMessageInfo(message) {
      var _this4 = this;
      if (!message) {
        this.message_info_open = null;
      } else if (this.message_info_open === message) {
        // Already open, do nothing
      } else if (this.canShowInfoForMessage(message)) {
        var sel = window.getSelection();
        if (sel.rangeCount > 0) {
          var range = sel.getRangeAt(0);
          if (range && !range.collapsed) {
            return;
          }
        }
        this.message_info_open = message;
        this.$nextTick(function () {
          return _this4.maybeScrollToId(message.id);
        });
      }
    },
    handleDocumentClick: function handleDocumentClick(event) {
      // Close message info when clicking outside the message list,
      // especially on the input editor (kiwi-ircinput-editor)
      var messagelist = this.$el;
      var target = event.target;
      if (this.message_info_open && messagelist && !messagelist.contains(target) && !target.closest('.kiwi-messageinfo')) {
        this.toggleMessageInfo();
      }
    },
    shouldShowUnreadMarker: function shouldShowUnreadMarker(message) {
      var idx = this.filteredMessages.indexOf(message);
      var previous = this.filteredMessages[idx - 1];
      var current = this.filteredMessages[idx];
      var lastRead = this.buffer.last_read;
      if (!lastRead) {
        return false;
      }
      if (!current) {
        return false;
      }
      if (previous && previous.time < lastRead && current.time > lastRead) {
        return true;
      }
      return false;
    },
    shouldShowDateChangeMarker: function shouldShowDateChangeMarker(idx) {
      var previous = this.filteredMessages[idx - 1];
      var current = this.filteredMessages[idx];
      if (!previous && new Date(current.time).getDay() !== new Date().getDay()) {
        return true;
      } else if (!previous) {
        return false;
      }
      if (new Date(previous.time).getDay() !== new Date(current.time).getDay()) {
        return true;
      }
      return false;
    },
    canShowInfoForMessage: function canShowInfoForMessage(message) {
      var showInfoForTypes = ['privmsg', 'notice', 'action'];
      return showInfoForTypes.indexOf(message.type) > -1;
    },
    canShowReactions: function canShowReactions(message) {
      var showForTypes = ['privmsg', 'notice', 'action'];
      if (message.template) return false;
      return showForTypes.indexOf(message.type) > -1;
    },
    bufferSetting: function bufferSetting(key) {
      return this.buffer.setting(key);
    },
    formatTime: function formatTime(time) {
      return (0, _strftime.default)(this.buffer.setting('timestamp_format') || '%T', new Date(time));
    },
    formatTimeFull: function formatTimeFull(time) {
      var format = this.buffer.setting('timestamp_full_format');
      return format ? (0, _strftime.default)(format, new Date(time)) : new Date(time).toLocaleString();
    },
    formatMessage: function formatMessage(message) {
      return message.toHtml(this);
    },
    isMessageHighlight: function isMessageHighlight(message) {
      if (message.type === 'traffic') {
        return false;
      }
      return message.isHighlight;
    },
    userColour: function userColour(user) {
      if (user && this.bufferSetting('colour_nicknames_in_messages')) {
        return user.getColour();
      }
      return '';
    },
    openUserBox: function openUserBox(nick) {
      var user = this.$state.getUser(this.buffer.networkid, nick);
      if (user) {
        this.$state.$emit('userbox.show', user, {
          buffer: this.buffer
        });
      }
    },
    onListClick: function onListClick() {
      this.toggleMessageInfo();
    },
    onMessageDblClick: function onMessageDblClick(event, message) {
      clearTimeout(this.messageClickTmr);
      var dataNick = event.target.getAttribute('data-nick');
      if (!dataNick) {
        return;
      }
      var network = this.buffer.getNetwork();
      var user = network.userByName(dataNick);
      var nick = user && user.nick ? user.nick : dataNick;
      this.$state.$emit('input.insertnick', nick);
    },
    onMessageClick: function onMessageClick(event, message, delay) {
      if (delay && event.target.getAttribute('data-nick')) {
        clearTimeout(this.messageClickTmr);
        this.messageClickTmr = setTimeout(this.onMessageClick, 200, event, message, false);
        return;
      }
      var isLink = event.target.tagName === 'A';
      var channelName = event.target.getAttribute('data-channel-name');
      if (channelName && isLink) {
        var network = this.buffer.getNetwork();
        this.$state.addBuffer(this.buffer.networkid, channelName);
        network.ircClient.join(channelName);
        this.$state.setActiveBuffer(this.buffer.networkid, channelName);
        return;
      }
      var userNick = event.target.getAttribute('data-nick');
      if (userNick && isLink) {
        this.openUserBox(userNick);
        return;
      }
      var url = event.target.getAttribute('data-url');
      if (url && isLink) {
        if (this.$state.setting('buffers.inline_link_auto_previews')) {
          message.embed.type = 'url';
          message.embed.payload = url;
        } else {
          this.$state.$emit('mediaviewer.show', url);
        }
        return;
      }
      var avatarElement = event.target.closest('.kiwi-avatar');
      if (avatarElement && avatarElement.dataset.nick) {
        this.openUserBox(avatarElement.dataset.nick);
        return;
      }
      if (this.message_info_open && this.message_info_open !== message) {
        this.toggleMessageInfo();
        event.preventDefault();
        return;
      }
      if (this.$state.setting('buffers.show_message_info')) {
        if (this.canShowInfoForMessage(message) && event.target.nodeName === 'A') {
          event.preventDefault();
        }
        this.toggleMessageInfo(message);
      }
    },
    checkScrollingState: function checkScrollingState() {
      var el = this.$el;
      var scrolledUp = el.scrollHeight - Math.round(el.scrollTop) - el.clientHeight;
      if (scrolledUp <= AUTO_SCROLL_MARGIN) {
        this.auto_scroll = true;
        this.buffer.isMessageTrimming = true;
      } else {
        this.auto_scroll = false;
        this.buffer.isMessageTrimming = false;
      }
      if (this.force_smooth_scroll !== null) {
        this.smooth_scroll = this.force_smooth_scroll;
        this.force_smooth_scroll = null;
      } else {
        this.smooth_scroll = false;
      }
    },
    onListResize: function onListResize() {
      this.maybeScrollToBottom();
    },
    checkScroll: function checkScroll() {
      var scroller = this.$refs.scroller;
      if (!scroller) {
        return;
      }
      var scrolledUp = scroller.scrollHeight - Math.round(scroller.scrollTop) - scroller.clientHeight;
      var atBottom = scrolledUp <= AUTO_SCROLL_MARGIN;
      this.auto_scroll = atBottom;
      if (atBottom) {
        this.userScrolledUp = false;
        this.showButton = false;
      } else {
        this.userScrolledUp = true;
        var buttonThresholdPx = this.avgMessageHeight * SCROLL_BUTTON_MESSAGE_THRESHOLD;
        this.showButton = scrolledUp > buttonThresholdPx;
      }
    },
    handleScroll: function handleScroll() {
      this.checkScroll();
    },
    scrollToBottom: function scrollToBottom() {
      var scroller = this.$refs.scroller;
      if (!scroller) {
        return;
      }
      scroller.scrollTop = scroller.scrollHeight;
      this.auto_scroll = true;
      this.showButton = false;
      this.userScrolledUp = false;
    },
    maybeScrollToBottom: function maybeScrollToBottom() {
      var _this5 = this;
      if (this.auto_scroll) {
        requestAnimationFrame(function () {
          _this5.scrollToBottom();
        });
      }
    },
    maybeScrollToId: function maybeScrollToId(id) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'middle';
      var msgEl = this.$el.querySelector('.kiwi-messagelist-message[data-message-id="' + id + '"]');
      if (!msgEl) {
        return;
      }
      var newTop = 0;
      if (position === 'top') {
        newTop = msgEl.offsetTop;
      } else if (position === 'bottom') {
        newTop = Math.floor(msgEl.offsetTop - this.$refs.scroller.offsetHeight + msgEl.offsetHeight);
      } else {
        newTop = Math.floor(msgEl.offsetTop - (this.$refs.scroller.offsetHeight - msgEl.offsetHeight) / 2);
      }
      this.auto_scroll = false;
      this.$refs.scroller.scrollTo({
        top: newTop,
        behavior: 'smooth'
      });
    },
    getSelectedMessages: function getSelectedMessages() {
      var sel = document.getSelection();
      var r = sel.getRangeAt(0);
      var messageEls = (0, _toConsumableArray2.default)(this.$el.querySelectorAll('.kiwi-messagelist-message'));
      var selectedMessageEls = (0, _filter.default)(messageEls).call(messageEls, function (el) {
        return r.intersectsNode(el);
      });
      return selectedMessageEls;
    },
    restrictTextSelection: function restrictTextSelection() {
      document.querySelector('body').classList.add('kiwi-unselectable');
      this.$el.style.userSelect = 'text';
    },
    unrestrictTextSelection: function unrestrictTextSelection() {
      document.querySelector('body').classList.remove('kiwi-unselectable');
      this.$el.style.userSelect = 'auto';
    },
    removeSelections: function removeSelections() {
      var removeNative = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.selectedMessages = Object.create(null);
      var selection = document.getSelection();
      if (removeNative && selection) {
        selection.removeAllRanges();
      }
    },
    addCopyListeners: function addCopyListeners() {
      var _this6 = this;
      var LogFormatter = function LogFormatter(msg) {
        var text = '';
        switch (msg.type) {
          case 'privmsg':
            text = '<' + msg.nick + '> ' + msg.message;
            break;
          case 'nick':
          case 'mode':
          case 'action':
          case 'traffic':
            text = '' + msg.message;
            break;
          default:
            text = msg.message;
        }
        if (text.length) {
          return '[' + new Date(msg.time).toLocaleTimeString({
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          }) + '] ' + text;
        }
        return null;
      };
      var copyData = '';
      var selecting = false;
      var selectionChangeOff = null;
      this.listen(document, 'selectstart', function (e) {
        if (!_this6.$el.contains(e.target)) {
          copyData = '';
          _this6.removeSelections();
          return;
        }
        _this6.removeSelections();
        selectionChangeOff = _this6.listen(document, 'selectionchange', onSelectionChange);
      });
      this.listen(document, 'mouseup', function (e) {
        selectionChangeOff && selectionChangeOff();
        _this6.unrestrictTextSelection();
        if (selecting) {
          e.preventDefault();
        }
        selecting = false;
      });
      var onSelectionChange = function onSelectionChange() {
        if (!_this6.$el) {
          return true;
        }
        copyData = '';
        var selection = document.getSelection();
        if (!selection || !selection.anchorNode || !selection.anchorNode.parentNode.closest('.' + _this6.$el.className)) {
          _this6.unrestrictTextSelection();
          _this6.removeSelections();
          return true;
        }
        _this6.removeSelections();
        _this6.restrictTextSelection();
        if (selection.rangeCount > 0) {
          var _context2, _context3;
          selecting = true;
          var selectedMesssageEls = _this6.getSelectedMessages();
          var selectedMessages = [];
          selectedMesssageEls.forEach(function (el) {
            var m = _this6.buffer.messagesObj.messageIds[el.dataset.messageId];
            if (m) {
              selectedMessages.push(m);
            }
          });
          if (selectedMessages.length === 1) {
            selectedMessages.length = 0;
          }
          _this6.selectedMessages = Object.create(null);
          selectedMessages.forEach(function (m) {
            _this6.selectedMessages[m.id] = m;
          });
          copyData = (0, _map.default)(_context2 = (0, _filter.default)(_context3 = (0, _sort.default)(selectedMessages).call(selectedMessages, function (a, b) {
            return a.time > b.time ? 1 : -1;
          })).call(_context3, function (m) {
            var _context4;
            return (0, _trim.default)(_context4 = m.message).call(_context4).length;
          })).call(_context2, LogFormatter).join('\r\n');
        } else {
          _this6.unrestrictTextSelection();
        }
        return false;
      };
      this.listen(document, 'copy', function (e) {
        if (!copyData || !copyData.length) {
          return true;
        }
        if (navigator.clipboard) {
          navigator.clipboard.writeText(copyData);
        } else {
          var input = document.createElement('textarea');
          document.body.appendChild(input);
          input.innerHTML = copyData;
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
        }
        return true;
      });
    },
    openEmbedInPreview: function openEmbedInPreview(message) {
      var embed = message.embed;
      if (embed.type === 'url') {
        this.$state.$emit('mediaviewer.show', embed.payload);
      } else if (embed.type === 'component') {
        this.$state.$emit('mediaviewer.show', {
          component: embed.payload
        });
      }
      embed.payload = null;
    },
    debounce: function debounce(func, wait) {
      var _this7 = this;
      var timeout;
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          return func.apply(_this7, args);
        }, wait);
      };
    }
  }
};